export function Globe02Icon({ className }: { className?: string }) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1482_564)">
        <path
          d="M9.99984 1.66669C12.0842 3.94865 13.2688 6.91005 13.3332 10C13.2688 13.09 12.0842 16.0514 9.99984 18.3334M9.99984 1.66669C7.91544 3.94865 6.73088 6.91005 6.6665 10C6.73088 13.09 7.91544 16.0514 9.99984 18.3334M9.99984 1.66669C5.39746 1.66669 1.6665 5.39765 1.6665 10C1.6665 14.6024 5.39746 18.3334 9.99984 18.3334M9.99984 1.66669C14.6022 1.66669 18.3332 5.39765 18.3332 10C18.3332 14.6024 14.6022 18.3334 9.99984 18.3334M2.08319 7.50002H17.9165M2.08317 12.5H17.9165"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1482_564">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
